import { render, staticRenderFns } from "./commonContent.vue?vue&type=template&id=92dbb1ee&scoped=true&"
import script from "./commonContent.vue?vue&type=script&lang=js&"
export * from "./commonContent.vue?vue&type=script&lang=js&"
import style0 from "./commonContent.vue?vue&type=style&index=0&id=92dbb1ee&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92dbb1ee",
  null
  
)

export default component.exports